import { setExcelFilters } from 'store/excelExport/excelExportSlice';
import {
  getContentRequestQAndQueryId,
  getPlatforms,
  getRequestLanguages,
  getRequestTimeDuration,
  magicNumbers,
  mapToApiPlatform,
  platformToReducerName,
} from 'utils';
import { isEmpty, isObject, isNull, isUndefined } from 'lib';

export const handleApplySettingsFilters = (state, action) => {
  const { filters, sortBy, filtersInitialState } = action.payload;
  const {
    resourceCategoryFilter,
    resourcesFilter,
    contentTypeFilter,
    advertFilter,
    languageFilter,
    commentsOrRelatedPostComments,
    contentCategoryFilter,
    contentBasedFilter,
  } = filters || {};
  if (resourceCategoryFilter) {
    state.filters.resourceCategoryFilter.selectedValue =
      resourceCategoryFilter?.selectedValue;
    state.filters.resourceCategoryFilter.hasFilter = Boolean(
      resourceCategoryFilter?.selectedValue
    );
  }
  if (resourcesFilter) {
    const settingsSelectedItems =
      Array.isArray(resourcesFilter?.selectedItems) ||
      !resourcesFilter?.selectedItems
        ? {}
        : resourcesFilter?.selectedItems;
    state.filters.resourcesFilter.selectedValue =
      resourcesFilter?.selectedValue;
    state.filters.resourcesFilter.selectedItems = settingsSelectedItems;
    state.filters.resourcesFilter.hasFilter =
      Object.keys(settingsSelectedItems).length > 0 ||
      resourcesFilter?.selectedValue !== 'include';
  }
  if (contentTypeFilter) {
    state.filters.contentTypeFilter.selectedValue =
      contentTypeFilter?.selectedValue;
    state.filters.contentTypeFilter.hasFilter =
      contentTypeFilter?.selectedValue !==
      filtersInitialState?.contentTypeFilter.selectedValue;
  }
  if (advertFilter) {
    const isActive = advertFilter?.selectedObjectValues?.max === 1;
    state.filters.advertFilter.selectedObjectValues.min =
      advertFilter?.selectedObjectValues?.min;
    state.filters.advertFilter.selectedObjectValues.max =
      advertFilter?.selectedObjectValues?.max;
    state.filters.advertFilter.selectedObjectValues.active = isActive;
    state.filters.advertFilter.hasFilter = isActive;
  }
  if (languageFilter) {
    state.filters.languageFilter.selectedValue = languageFilter?.selectedValue;
    state.filters.languageFilter.hasFilter =
      languageFilter?.selectedValue !==
      filtersInitialState?.languageFilter.selectedValue;
  }
  if (
    commentsOrRelatedPostComments &&
    state.filters.commentsOrRelatedPostComments
  ) {
    state.filters.commentsOrRelatedPostComments.selectedValue =
      commentsOrRelatedPostComments?.selectedValue;
  }

  if (contentCategoryFilter) {
    state.filters.contentCategoryFilter.selectedCategories =
      contentCategoryFilter?.selectedCategories;
    state.filters.contentCategoryFilter.hasFilter = !isEmpty(
      contentCategoryFilter?.selectedCategories
    );
  }

  const filtersWithSelectedIds = [
    'platformFilter',
    'hashtagCloudFilter',
    'wordCloudFilter',
    'contentTagFilter',
    'genderFilter',
    'ageFilter',
    'mediaTypeFilter',
    'resourceTypeFilter',
    'subjectFilter',
  ];
  filtersWithSelectedIds.forEach((filterName) => {
    if (isObject(state.filters[filterName]) && isObject(filters[filterName])) {
      state.filters[filterName].selectedIds =
        filters?.[filterName]?.selectedIds;
      state.filters[filterName].hasFilter = !isEmpty(
        filters?.[filterName]?.selectedIds
      );
    }
  });

  if (contentBasedFilter) {
    if (state.filters.contentBasedFilter?.selectedObjects?.influenceRate) {
      state.filters.contentBasedFilter.selectedObjects.influenceRate.selectedIds =
        contentBasedFilter.selectedObjects.influenceRate.selectedIds;
      state.filters.contentBasedFilter.selectedObjects.influenceRate.active =
        !isEmpty(
          contentBasedFilter.selectedObjects?.influenceRate?.selectedIds
        );
    }
    if (state.filters.contentBasedFilter?.selectedObjects?.like) {
      state.filters.contentBasedFilter.selectedObjects.like.min =
        contentBasedFilter?.selectedObjects?.like?.min;
      state.filters.contentBasedFilter.selectedObjects.like.max =
        contentBasedFilter?.selectedObjects?.like?.max;
      state.filters.contentBasedFilter.selectedObjects.like.active =
        !isNull(contentBasedFilter?.selectedObjects?.like?.min) &&
        !isUndefined(contentBasedFilter?.selectedObjects?.like?.min);
    }
    if (state.filters.contentBasedFilter?.selectedObjects?.comment) {
      state.filters.contentBasedFilter.selectedObjects.comment.min =
        contentBasedFilter?.selectedObjects?.comment?.min;
      state.filters.contentBasedFilter.selectedObjects.comment.max =
        contentBasedFilter?.selectedObjects?.comment?.max;
      state.filters.contentBasedFilter.selectedObjects.comment.active =
        !isNull(contentBasedFilter?.selectedObjects?.comment?.min) &&
        !isUndefined(contentBasedFilter?.selectedObjects?.comment?.min);
    }
    if (state.filters.contentBasedFilter?.selectedObjects?.view) {
      state.filters.contentBasedFilter.selectedObjects.view.min =
        contentBasedFilter?.selectedObjects?.view?.min;
      state.filters.contentBasedFilter.selectedObjects.view.max =
        contentBasedFilter?.selectedObjects?.view?.max;
      state.filters.contentBasedFilter.selectedObjects.view.active =
        !isNull(contentBasedFilter?.selectedObjects?.view?.min) &&
        !isUndefined(contentBasedFilter?.selectedObjects?.view?.min);
    }
    if (state.filters.contentBasedFilter?.selectedObjects?.copy) {
      state.filters.contentBasedFilter.selectedObjects.copy.min =
        contentBasedFilter?.selectedObjects?.copy?.min;
      state.filters.contentBasedFilter.selectedObjects.copy.max =
        contentBasedFilter?.selectedObjects?.copy?.max;
      state.filters.contentBasedFilter.selectedObjects.copy.active =
        !isNull(contentBasedFilter?.selectedObjects?.copy?.min) &&
        !isUndefined(contentBasedFilter?.selectedObjects?.copy?.min);
    }
    state.filters.contentBasedFilter.hasFilter =
      !isEmpty(
        contentBasedFilter.selectedObjects?.influenceRate?.selectedIds
      ) ||
      (!isNull(contentBasedFilter?.selectedObjects?.like?.min) &&
        !isUndefined(contentBasedFilter?.selectedObjects?.like?.min)) ||
      (!isNull(contentBasedFilter?.selectedObjects?.comment?.min) &&
        !isUndefined(contentBasedFilter?.selectedObjects?.comment?.min)) ||
      (!isNull(contentBasedFilter?.selectedObjects?.view?.min) &&
        !isUndefined(contentBasedFilter?.selectedObjects?.view?.min)) ||
      (!isNull(contentBasedFilter?.selectedObjects?.copy?.min) &&
        !isUndefined(contentBasedFilter?.selectedObjects?.copy?.min));
  }

  if (sortBy) {
    state.sortBy = sortBy;
  }
};

const getPlatformPayload = (platform) => {
  let payload = {};

  // eslint-disable-next-line default-case
  switch (platform) {
    case 'multiPlatform': {
      payload = {
        api_path: '/multi-platform/posts',
      };
      break;
    }
    case 'news':
    case 'news-copy': {
      payload = {
        api_path: '/news/posts',
        source: 'both',
      };
      break;
    }
    case 'instagram': {
      payload = {
        api_path: '/instagram/posts',
      };
      break;
    }
    case 'instagramComment': {
      payload = {
        api_path: '/instagram/comments',
        exclude_unknown: 1,
      };
      break;
    }
    case 'instagramCommentByPost': {
      payload = {
        api_path: '/instagram/comments/by_posts',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
        exclude_unknown: 1,
      };
      break;
    }
    case 'twitter': {
      payload = {
        api_path: '/twitter/posts',
        source: 'original',
      };
      break;
    }
    case 'virasty': {
      payload = {
        api_path: '/virasty/posts',
        source: 'original',
      };
      break;
    }
    case 'telegram': {
      payload = {
        api_path: '/telegram/posts',
        source: 'both',
      };
      break;
    }
    case 'newspaper': {
      payload = {
        api_path: '/newspaper/posts',
        want_republishers: 1,
      };
      break;
    }
    case 'nativePlatforms': {
      payload = {
        api_path: '/iranian-platforms/posts',
      };
      break;
    }
    case 'linkedin': {
      payload = {
        api_path: '/linkedin/posts',
      };
      break;
    }
  }
  return payload;
};

export const getContentPayload = (platform, thunkAPI) => {
  const filterReducerState =
    thunkAPI.getState()[platformToReducerName[platform]];

  const wantTagContent =
    thunkAPI.getState().settingsReducer.filters.public.wantTagContent
      ?.selectedValue;
  const { filters } = filterReducerState;
  const { sortBy } = filterReducerState;
  const { pageReducer, settingsReducer, filterReducer, contentReducer } =
    thunkAPI.getState();
  const { currentDate, currentQuery } = pageReducer;

  const payload = getPlatformPayload(platform);

  const subCategories = Object.values(
    filters?.contentCategoryFilter?.selectedCategories || {}
  );
  const { q, queryId } = getContentRequestQAndQueryId({
    currentQuery,
    resultSearchQuery: contentReducer.resultSearchQuery[platform],
    isActivePlatform:
      filterReducer?.filtersContext === platformToReducerName[platform],
  });

  const finalParams = {
    ...payload,
    q: q || undefined,
    query: queryId || undefined,
    from: currentDate?.timeDuration ? undefined : currentDate?.fromDate,
    to: currentDate?.timeDuration ? undefined : currentDate?.toDate,
    time_duration: getRequestTimeDuration(currentDate),
    page: 1,
    count:
      settingsReducer?.filters?.public?.pageContentCountSlider?.selectedValue,
    sort: sortBy?.selected,
    sort_type: sortBy?.order,
    langs: getRequestLanguages(filters),
    content_tag_ids: filters?.contentTagFilter?.selectedIds ?? undefined,
    extracted_phrases: filters?.wordCloudFilter?.selectedIds ?? undefined,
    extracted_hashtags: filters?.hashtagCloudFilter?.selectedIds ?? undefined,
    want_tag_content: wantTagContent ? 1 : 0,
    //sentiment: telegram, twitter, instagram, instagramComment
    sentiments: Object.keys(
      filters?.sentimentFilter?.selectedValues || {}
    ).filter(
      (sentiment) =>
        filters?.sentimentFilter?.selectedValues[sentiment] !== false
    ),

    //advert_noise: instagram
    min_advert_noise:
      filters?.advertFilter?.selectedObjectValues?.min ?? undefined,
    max_advert_noise:
      filters?.advertFilter?.selectedObjectValues?.max ?? undefined,
    //relation_influence: twitter, telegram, news, instagram
    resource_influence_categories: filters?.contentBasedFilter?.selectedObjects
      ?.influenceRate?.active
      ? filters?.contentBasedFilter?.selectedObjects?.influenceRate.selectedIds
      : undefined,
    //view: telegram
    min_view:
      filters?.contentBasedFilter?.selectedObjects?.view?.min ?? undefined,
    max_view:
      filters?.contentBasedFilter?.selectedObjects?.view?.max ?? undefined,
    //lik: twitter, instagram
    min_like:
      filters?.contentBasedFilter?.selectedObjects?.like?.min ?? undefined,
    max_like:
      filters?.contentBasedFilter?.selectedObjects?.like?.max ?? undefined,
    //reaction: virasty (has no likes, sends reactions instead)
    min_reactions:
      filters?.contentBasedFilter?.selectedObjects?.reaction?.min ?? undefined,
    max_reactions:
      filters?.contentBasedFilter?.selectedObjects?.reaction?.max ?? undefined,
    //copy: twitter
    min_copy:
      filters?.contentBasedFilter?.selectedObjects?.copy?.min ?? undefined,
    max_copy:
      filters?.contentBasedFilter?.selectedObjects?.copy?.max ?? undefined,
    //comment: instagram
    min_comment:
      filters?.contentBasedFilter?.selectedObjects?.comment?.min ?? undefined,
    max_comment:
      filters?.contentBasedFilter?.selectedObjects?.comment?.max ?? undefined,
    //source: twitter, telegram, news
    source:
      filters?.contentTypeFilter?.selectedValue === 'both'
        ? undefined
        : filters?.contentTypeFilter?.selectedValue,
    //seenStatus
    is_seen:
      filters?.seenStatusFilter?.selectedValue === 'both'
        ? undefined
        : Number(filters?.seenStatusFilter?.selectedValue === 'true'),
    //categories: twitter, telegram, news, instagram
    categories:
      Object.keys(filters?.contentCategoryFilter?.selectedCategories || {}) ||
      undefined,
    sub_categories:
      subCategories?.length > 0 ? subCategories?.flat(1) : undefined,
    //resource_categories: newspaper
    resource_categories: filters?.subjectFilter?.selectedIds ?? undefined,
    [filters?.resourcesFilter?.selectedValue === 'include'
      ? 'resource_ids'
      : 'not_resource_ids']: Object.keys(
      filters?.resourcesFilter?.selectedItems || {}
    ),
    [filters?.resourceCategoryFilter?.filterType === 'include'
      ? 'tag_id'
      : 'not_tag_id']:
      filters?.resourceCategoryFilter?.selectedValue || undefined,
    //resource_ids: instagramComment
    post_resource_ids: Object.keys(
      filters?.resourcesFilter?.selectedItems || {}
    ),
    //age: twitter, instagram
    m3_age: filters?.ageFilter?.selectedIds ?? undefined,
    gender: filters?.genderFilter?.selectedIds ?? undefined,
    platforms: getPlatforms()
      .filter((platform) =>
        filters?.platformFilter?.selectedIds?.includes(platform)
      )
      .map((platform) => mapToApiPlatform[platform]),
  };

  if (
    platform === 'instagram' ||
    platform === 'twitter' ||
    platform === 'telegram' ||
    platform === 'virasty'
  ) {
    finalParams.want_vip_flag = 1;
    finalParams.smart_highlight = 1;
  }

  if (platform === 'news' || platform === 'news-copy') {
    finalParams.media_types =
      filters?.resourceTypeFilter?.selectedIds ?? undefined;
    finalParams.resource_countries =
      filters?.countryFilter?.selectedIds?.length > 0
        ? filters?.countryFilter?.selectedIds
        : undefined;
    finalParams.smart_highlight = 1;
  } else {
    finalParams.media_types =
      filters?.mediaTypeFilter?.selectedIds ?? undefined;
  }

  // بازنشرهای یک مطلب مستقل از بازه زمانی انتخاب‌شده در هدر مطالب نمایش داده می‌شوند
  if (platform === 'news-copy') {
    finalParams.is_seen = undefined;
    finalParams.from = undefined;
    finalParams.to = undefined;
    finalParams.time_duration = undefined;
  }

  if (filters?.mediaTypeFilter?.selectedIds?.includes('other')) {
    finalParams.media_types = [
      'article',
      'document',
      'poll',
      ...(filters?.mediaTypeFilter?.selectedIds?.filter(
        (mediaType) => mediaType !== 'other'
      ) || []),
    ];
  }
  if (platform === 'nativePlatforms') {
    const { selectedNativePlatforms } =
      thunkAPI.getState().nativePlatformsContentReducer;
    finalParams.smart_highlight = 1;

    if (selectedNativePlatforms.length > 0)
      finalParams.platforms = selectedNativePlatforms;
  }

  if (platform === 'linkedin') {
    finalParams.smart_highlight = 1;
  }

  if (filterReducer?.filtersContext === platformToReducerName[platform]) {
    thunkAPI.dispatch(
      setExcelFilters({
        params: { ...finalParams },
        exportPage: 'content',
        exportPlatform: platform,
      })
    );
  }

  return finalParams;
};
